import { render, staticRenderFns } from "./401.vue?vue&type=template&id=cbc28918&scoped=true"
import script from "./401.vue?vue&type=script&lang=js"
export * from "./401.vue?vue&type=script&lang=js"
import style0 from "./401.vue?vue&type=style&index=0&id=cbc28918&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc28918",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbc28918')) {
      api.createRecord('cbc28918', component.options)
    } else {
      api.reload('cbc28918', component.options)
    }
    module.hot.accept("./401.vue?vue&type=template&id=cbc28918&scoped=true", function () {
      api.rerender('cbc28918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error-page/401.vue"
export default component.exports